import React from "react";
import PrivacyPolicy from "./PrivacyPolicy";
import { PrivacyPolicyData } from "../datas";

const Home = () => {
  return (
    <div>
      <PrivacyPolicy />
    </div>
  );
};

export default Home;
